import React from 'react';
import { render } from 'react-dom';
import 'global-styles/custom-fonts.scss';
// import { getCustomConfig } from './utils/get-config';
import App from './app';

export const initAG = () => {
  // const customConfig = await getCustomConfig();

  /* Generate root element for cookies consent app, 
  we need to do this in order
  to inject app inside any website's DOM */
  const rootElement = document.createElement('div');
  rootElement.id = 'cbg-ag-popup';
  document.body.appendChild(rootElement);
  render(<App />, rootElement);
};

initAG();
